import { INotificationApiCall, IRestApiService, Notification, Subscriber } from "../types";

class NotificationApiCall implements INotificationApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getNotificationsById(id: string): Promise<Notification[]> {
    return this.restApiService.get('notification/studio/' + id);
  }

  getNotification(id: string): Promise<Notification> {
    return this.restApiService.get('notification/' + id);
  }

  addNotification(ownerId: string, studioId: string, notification: Notification): Promise<Notification> {
    return this.restApiService.post(`notification/${ownerId}/${studioId}`, {
      notification: notification,
    });
  }

  updateNotification(ownerId: string, studioId: string, id: string, notification: Notification): Promise<Notification> {
    return this.restApiService.put(
      `notification/${ownerId}/${studioId}/${id}`,
      { notification: notification }
    );
  }

  deleteNotification(id: string): Promise<void> {
    return this.restApiService.delete(`notification/${id}`);
  }

  subscribe(subscriber: Subscriber): Promise<any> {
    return this.restApiService.post('subscriber', { subscriber: subscriber });
  }

  unsubscribe(id: string): Promise<void> {
    return this.restApiService.delete('subscriber/' + id);
  }
}

export default NotificationApiCall;